import { Heading, List } from 'ui/components/primitives';
import { styled, theme, utils } from 'ui/theme';

const HeaderSearch = {
  Wrapper: styled('div')`
    display: flex;
    flex-flow: column;
    gap: ${theme.space[2]};
    padding: ${theme.space[3]} 0;
    width: 100%;
    z-index: ${theme.zIndices.drawer};

    ${utils.media.min('l')`
      position: relative;
      padding: 0;
    `}
  `,

  List: styled(List)`
    overflow-y: auto;
    width: 100%;
    max-height: calc(${theme.space[23]} * 5);

    &[data-visible='false'] {
      display: none;
    }

    ${utils.media.min('l')`
      margin-top: ${theme.space[5]};
      max-height: calc(${theme.space[23]} * 4);
      position: absolute;
      top: 100%;
      left: 0;
    `}
  `,

  Empty: styled('div')`
    align-items: center;
    background-color: #ffffff;
    border-radius: ${theme.radii.small};
    display: flex;
    flex-direction: column;
    max-height: calc(${theme.space[23]} * 5);
    overflow-y: auto;
    padding: ${theme.space[6]};
    width: 100%;

    svg {
      width: ${theme.space[15]};
      height: ${theme.space[15]};
    }

    &[data-visible='false'] {
      display: none;
    }

    ${utils.media.min('l')`
    margin-top: ${theme.space[5]};
    max-height: calc(${theme.space[23]} * 4);
    position: absolute;
    top: 100%;
    left: 0;
  `}
  `,

  Title: styled(Heading)`
    margin-bottom: ${theme.space[2]};
    margin-top: ${theme.space[1]};
  `,
};

export default HeaderSearch;
